import { render, staticRenderFns } from "./UploadFileCodesys.vue?vue&type=template&id=93c20ac0"
import script from "./UploadFileCodesys.vue?vue&type=script&lang=js"
export * from "./UploadFileCodesys.vue?vue&type=script&lang=js"
import style0 from "./UploadFileCodesys.vue?vue&type=style&index=0&id=93c20ac0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports